import t from './theme';

var getToasterBackgroundColor = function getToasterBackgroundColor(props) {
  switch (props.type) {
    case 'success':
      return t.getSuccessfulBackgroundColor;

    case 'warning':
      return t.getWarningBackgroundColor;

    case 'error':
      return t.getErrorBackgroundColor;

    default:
      return t.getSuccessfulBackgroundColor;
  }
};

var getToasterTextColor = function getToasterTextColor(props) {
  switch (props.type) {
    case 'success':
      return t.getSuccessfulTextColor;

    case 'warning':
      return t.getWarningTextColor;

    case 'error':
      return t.getErrorTextColor;

    default:
      return t.getSuccessfulBackgroundColor;
  }
};

export default {
  getToasterBackgroundColor: getToasterBackgroundColor,
  getToasterTextColor: getToasterTextColor
};